import { render, staticRenderFns } from "./OnCallWorkOrdersListPage.vue?vue&type=template&id=ca8e7660&scoped=true"
import script from "./OnCallWorkOrdersListPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./OnCallWorkOrdersListPage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OnCallWorkOrdersListPage.vue?vue&type=style&index=0&id=ca8e7660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8e7660",
  null
  
)

export default component.exports